import {
    ADD_NEWVERSION_FAILED,
    ADD_NEWVERSION_LOADING,
    ADD_NEWVERSION_REMOVE,
    ADD_NEWVERSION_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    versionData: null,
    request: null,
};

export const versionsCrudOperationsReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any, request: string }
) => {


    switch (action.type) {
        case ADD_NEWVERSION_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_NEWVERSION_SUCCESS:
            return {
                ...state,
                loading: false,
                versionData: action.payload,
                status: action.status,
                error: null,
                request: action.request
            };
        case ADD_NEWVERSION_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
                request: action.request
            };

        case ADD_NEWVERSION_REMOVE:
            return initialState

        default:
            return state;
    }
};




